<template lang="html">
    <section class="update-status">
        <h1>{{ $t("StatStatus.titleChangeStatus") }}</h1>
        <p v-if="msgChangeStatus[getCurrentLang()] && action.errorMsg">{{ msgChangeStatus[getCurrentLang()] }}</p>
        <p>{{ $t("StatStatus.contentStatus") }} "{{ getTranslate(action.value.terms.name) }}"</p>
        <button class="btn" @click.prevent="hideModal">{{ $t("StatStatus.cancel") }}</button>
        <button type="submit" class="btn" @click.prevent="updateThisStatus(action);">{{ $t("StatStatus.valider") }}</button>
    </section>
</template>

<script lang="js">
// import {mapActions} from 'vuex'
import httpService from '../../../components/service'
import cacheService from "@/services/cache";

export default {
    name: 'update-status',
    props: [
        'action'
    ],
    mounted () {

    },
    data () {
        return {
            msgChangeStatus: ''
        }
    },
    methods: {
        // ...mapActions({
        //     listCountDown: 'countdown/listCountDown'
        // }),
        getCurrentLang () {
            return cacheService.getUserLang()
        },
        updateThisStatus: function (value) {
            // console.log('value+::', value)
            // console.log('stringify::', JSON.stringify(value.value.label))
            let obj = {
                status: value.value.label.toLowerCase()
            }
            httpService.post('/plano/' + value.id + '/workflow', JSON.stringify(obj)).then(response => {
                console.log('+response+', response)
                if (response.code === 400 || response.code === 404) {
                    value.errorMsg = true
                    this.msgChangeStatus = {
                        en: 'Error. Please contact application Support',
                        fr: "Erreur. Veuillez contacter l'assistance "
                    }
                    // console.log('+response+', response.message)
                    console.error('...+ ERROR DeleteCountDown +....', response)
                    // this.listCountDown()
                } else {
                    this.$root.$emit('bv::hide::modal', 'defaultModalStatus')
                    location.reload()
                    // console.log('+response OK+', response)
                }
            })
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModalStatus')
        }
    },
    computed: {}
}
</script>

<style scoped lang="scss">
.update-status {
}
</style>



// WEBPACK FOOTER //
// UpdateStatus.vue?20e76916